import { render, staticRenderFns } from "./simple_azq_start.vue?vue&type=template&id=0e5e212a&scoped=true&lang=true&"
import script from "./simple_azq_start.vue?vue&type=script&lang=js&"
export * from "./simple_azq_start.vue?vue&type=script&lang=js&"
import style0 from "./simple_azq_start.vue?vue&type=style&index=0&id=0e5e212a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5e212a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VImg,VRow})
